import { render, staticRenderFns } from "./CharacterAlignment.vue?vue&type=template&id=7793efe7&"
import script from "./CharacterAlignment.vue?vue&type=script&lang=js&"
export * from "./CharacterAlignment.vue?vue&type=script&lang=js&"
import style0 from "./CharacterAlignment.vue?vue&type=style&index=0&id=7793efe7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports